import { Button } from '@mui/material';
import styles from './RampActions.module.css';
import { useDispatch } from 'react-redux';
import { activateRelayAction, getOrderedActiveSignals } from '../../relayUtils';

function RampActions({ config, classes }) {
    const dispatch = useDispatch();
    const { name, relaySlotId, signalLabels, transactionId } = config || {};

    const rampActions = getOrderedActiveSignals(signalLabels).map((signal) => {
        const { operation } = signal;
        return (
            <Button
                variant="outlined"
                size="large"
                color="primary"
                key={`${relaySlotId}_${operation}`}
                onClick={() => activateRelayAction(dispatch, transactionId, relaySlotId, operation)}
            >
                {signal.label}
            </Button>
        );
    });

    return (
        <div className={`${styles['ramp']} ${classes || ''}`}>
            <div className={styles['ramp__header']}>
                <p>{name}</p>
            </div>
            <div className={styles['ramp__actions']}>{rampActions}</div>
        </div>
    );
}

export default RampActions;

// async function activateRelay(relayId, operation) {
//     try {
//         console.log(`activateRelay(): ACTIVATING operation=${operation} on relayId=${relayId}`);
//         await axiosAiq.post(`/relay/submit/${relayId}?operation=${operation}`);
//         console.log(`activateRelay(): SUCCESSFUL operation=${operation} on relayId=${relayId}`);

//         showNotification({ title: 'SUUCCESS', variant: 'success' });
//     } catch (err) {
//         console.log(`activateRelay(): ERROR activating operation=${operation} on relayId=${relayId}`);
//         const title = `Error activating operation=${operation} on relayId=${relayId} `;
//         showNotification({ err, title });
//     }
// }
